import React from "react";
import { Input as AntInput } from "antd";
import { TextAreaProps } from "./types";

export class TextArea extends React.PureComponent<TextAreaProps> {
  public render() {
    return <AntInput.TextArea {...this.props} />;
  }
}
